import PreviewCustomerBill from './PreviewCustomerBill'

const Viewer = ({
  urls,
  files,
  className = '',
  previewSettings,
  isDeletable,
  deleteHandler
}: {
  urls: Array<string>
  files:Array<File>
  className?: string
  previewSettings: {isFluidWidth: boolean; width: number; height: number}
  isDeletable?: boolean
  deleteHandler?: (url: any,name:any) => void
}) => {
  return (
    <div>
      <div className={`${className}`}>
        <PreviewCustomerBill urls={urls} files={files} previewSettings={previewSettings} isDeletable={isDeletable} deleteHandler={deleteHandler} />
      </div>
    </div>
  )
}

export default Viewer
